import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalDealDetail } from "@colab/shared";

// GET /api/portal/deals/:id
//
// Phase 7 sub-bucket 5 — partner-portal deals rich rebuild.
//
// Resolves :id against both `deals` (partner-submitted) and
// `hubspot_deal_attributions` (post-acceptance). Includes the HubSpot owner
// chip data when the deal has been accepted into HubSpot (or when the row
// itself is attribution-only).
//
// 404 surfaces as ApiClientError with status=404; the detail page renders
// a "Deal not found" card. Same convention as mdf-detail-page.tsx.
export function useDealDetail(id: string | null) {
  return useQuery<PortalDealDetail, ApiClientError>({
    queryKey: queryKeys.portal.deals.detail(id ?? ""),
    queryFn: () => apiFetch<PortalDealDetail>(`/portal/deals/${id}`),
    enabled: !!id,
  });
}
